module.exports = __webpack_public_path__ + "img/icon_box_outlined_w.75b10fdd.svg";